<template>
  <CartNotification>
    <template #header>
      <VRow no-gutters class="align-center">
        <VCol cols="12">
          <VIcon color="successCheck">
            {{ icons.mdiCheck }}
          </VIcon>
          <span class="font-weight-bold font16">{{ text }}</span>
        </VCol>
      </VRow>
    </template>
    <template #content>
      <CartNotificationItem
        v-if="product"
        :product="product"
      />
      <ProductOfTheMonthProgressBar variant="flyout" class="mt-3" />
    </template>
    <template #action>
      <CartNotificationButton
        @terminate-notification="emits('terminate-notification')"
      />
    </template>
  </CartNotification>
</template>

<script setup lang="ts">
import { mdiCheck } from '@mdi/js'
import CartNotification from '~/components/notification/cart/base/CartNotification.vue'
import CartNotificationItem from '~/components/notification/cart/common/CartNotificationItem.vue'
import CartNotificationButton from '~/components/notification/cart/common/CartNotificationButton.vue'
import ProductOfTheMonthProgressBar from '~/components/cart/ProductOfTheMonthProgressBar.vue'
import type { CartProduct } from '~/types/cart'

const icons = { mdiCheck }

defineProps<{
  product?: CartProduct
}>()

const emits = defineEmits<{
  (e: 'terminate-notification'): void
}>()


const $i18n = useI18n()
const text = computed(() => {
  return $i18n.t('label.addedToCart')
})
</script>

<style lang="scss">

</style>
